import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "CatalogueFamilyList" })
export default class CatalogueFamilyList extends Vue {
    public localizer: any = Localizer;
    public familyListData: any = {};
    public familyGroups: any[] = [];
    public resetFiltersUrl: string = null;
    public isLoading: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    get encodedFilters(): any {
        return this.$store.getters["catalogueStore/encodedFilters"];
    }

    get isContentLoading(): any {
        return this.$store.getters["catalogueStore/isContentLoading"];
    }

    @Watch("encodedFilters") onEncodedFiltersChanged(value: string, oldValue: string) {
        this.getData(value);
    }

    @Prop() readonly areaName: string;
    @Prop() readonly categoryName: string;
    @Prop() readonly familyCount: number;

    public async created() {
        const urlParams = new URLSearchParams(window.location.search);
        let encodedfilters = urlParams.get("filters");

        await this.getData(encodedfilters);
    }

    public async getData(encodedFilters: string) {
        this.$store.commit("catalogueStore/setIsContentLoading", true);

        this.familyListData = (await Axios.post(this.routes.Catalogue_GetFamilyListData, { areaName: this.areaName, categoryName: this.categoryName, filters: encodedFilters }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        this.familyGroups = this.familyListData.familyGroups;
        this.resetFiltersUrl = this.familyListData.resetFiltersUrl;

        this.$store.commit("catalogueStore/setIsContentLoading", false);
    }
};